var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.ordered ? 'ol' : 'ul',{tag:"component",staticClass:"ds-list",class:[
    _vm.size && ("ds-list-size-" + _vm.size)
]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }